import styled from 'styled-components';

type BackImageProps = {
  buttonPixelSize: string | number;
};

const BackImage = styled.img`
  width: ${(props: BackImageProps) => props.buttonPixelSize}px;
  height: ${(props: BackImageProps) => props.buttonPixelSize}px;
  min-width: ${(props: BackImageProps) => props.buttonPixelSize}px;
  margin-bottom: 1px;
`;

type Props = {
  // eslint-disable-next-line react/require-default-props
  onClick?: Function;
  size: String;
  // eslint-disable-next-line react/require-default-props
  buttonPixelSize?: string;
  // eslint-disable-next-line react/require-default-props
  fontSize?: string;
};

const BackButton = styled.a`
  display: ${({ onClick }: Props) =>
    onClick ? 'inline-flex' : 'none'};
  cursor: pointer;
  width: 50px;
  height: ${({ buttonPixelSize }: Props) => buttonPixelSize}px;
  margin-bottom: 16px;
  font-family: 'Nunito Sans', sans-serif;
  font-size: ${({ fontSize }: Props) => fontSize}px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.71;
  letter-spacing: normal;
  color: #6e0ad6;
  align-items: center;
`;

const Back = (props: Props) => {
  const { size } = props;
  let buttonPixelSize;
  switch (size) {
    case 'small':
      buttonPixelSize = '12';
      break;

    default:
      buttonPixelSize = '24';
      break;
  }

  return (
    // @ts-ignore
    <BackButton {...props}>
      <BackImage
        buttonPixelSize={buttonPixelSize}
        src="/images/chevron-left.svg"
        alt="back"
      />
      Voltar
    </BackButton>
  );
};

export default Back;
